import { render, staticRenderFns } from "./reaction-popup.vue?vue&type=template&id=f201db48"
import script from "./reaction-popup.vue?vue&type=script&lang=js"
export * from "./reaction-popup.vue?vue&type=script&lang=js"
import style0 from "./reaction-popup.vue?vue&type=style&index=0&id=f201db48&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports